// Extrai a primeira data `dd/mm` ou `dd/mm/aaaa` encontrada no texto.
// Retorna um Date (local) ou null. Para `dd/mm` sem ano, usa o ano corrente;
// se o resultado já ficou no passado, soma 1 ano.
//
// Serve ao aviso de divergência entre a data do campo e a data escrita no
// texto (pedido PROXIMA_ACAO_CLICAVEL_E_AVISO_DATA, Out/2026).
export function extractDateFromText(text, baseDate = new Date()) {
  if (!text || typeof text !== "string") return null;
  // dd/mm/aaaa (aaaa com 2 ou 4 dígitos)
  const rxFull = /\b(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})\b/;
  // dd/mm (sem ano) — garante que não é parte de uma data completa
  const rxShort = /(?<!\d)\b(\d{1,2})\/(\d{1,2})\b(?!\/\d)/;
  const mFull = text.match(rxFull);
  const mShort = !mFull ? text.match(rxShort) : null;
  if (!mFull && !mShort) return null;
  let d, m, y;
  if (mFull) {
    d = parseInt(mFull[1], 10);
    m = parseInt(mFull[2], 10);
    y = parseInt(mFull[3], 10);
    if (y < 100) y += 2000;
  } else {
    d = parseInt(mShort[1], 10);
    m = parseInt(mShort[2], 10);
    y = baseDate.getFullYear();
  }
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;
  // Monta como meia-noite local — compararemos só por dia.
  let out = new Date(y, m - 1, d);
  if (Number.isNaN(out.getTime())) return null;
  if (!mFull) {
    // Se a data sem ano cair antes de hoje, assume próximo ano.
    const hoje = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
    if (out.getTime() < hoje.getTime()) out = new Date(y + 1, m - 1, d);
  }
  return out;
}

// Compara se duas datas caem no mesmo dia (ano/mês/dia local).
export function isSameLocalDay(a, b) {
  if (!a || !b) return false;
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function fmtDiaBR(d) {
  if (!d) return "";
  return d.toLocaleDateString("pt-BR");
}
